import React from "react";
import $ from "jquery";
const Footer = React.lazy(() => import("./footer.jsx"));

const WrappedFooter = () => {
  return (
    <div>
      {$(".dxp-footer").length === 0 && (
        <>{!window.Microsoft && <Footer />}</>
      )}
    </div>
  );
};

export default WrappedFooter;